(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[564],{

/***/ 91516:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tournament/new",
      function () {
        return __webpack_require__(46527);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8428:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* reexport */ ProgressBar; },
  "_": function() { return /* reexport */ ProgressCircle; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./components/ui/progress/progressBar.module.scss
var progressBar_module = __webpack_require__(45326);
var progressBar_module_default = /*#__PURE__*/__webpack_require__.n(progressBar_module);
;// CONCATENATED MODULE: ./components/ui/progress/progressBar.tsx




var ProgressBar = function(param) {
    var _percent = param.percent, percent = _percent === void 0 ? 0 : _percent, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? 0.25 : _strokeWidth, description = param.description, _showDescription = param.showDescription, showDescription = _showDescription === void 0 ? true : _showDescription, fillColor = param.fillColor, backgroundColor = param.backgroundColor, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((progressBar_module_default()).barWrapper, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (progressBar_module_default()).barBackground,
                style: {
                    height: "".concat(strokeWidth, "rem"),
                    background: fillColor
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (progressBar_module_default()).barFill,
                    style: {
                        width: "".concat(100 - (percent > 100 ? 100 : percent < 0 ? 0 : percent), "%"),
                        height: "".concat(strokeWidth, "rem"),
                        background: backgroundColor
                    }
                })
            }),
            showDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (progressBar_module_default()).text,
                children: description !== null && description !== void 0 ? description : "".concat(percent, "%")
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/ui/icon/index.tsx + 1 modules
var ui_icon = __webpack_require__(22781);
// EXTERNAL MODULE: ./components/ui/progress/progressCircle.module.scss
var progressCircle_module = __webpack_require__(38659);
var progressCircle_module_default = /*#__PURE__*/__webpack_require__.n(progressCircle_module);
;// CONCATENATED MODULE: ./components/ui/progress/progressCircle.tsx





var ProgressCircle = function(param) {
    var _percent = param.percent, percent = _percent === void 0 ? 0 : _percent, _strokeWidth = param.strokeWidth, strokeWidth = _strokeWidth === void 0 ? 0.25 : _strokeWidth, icon = param.icon, progressColor = param.progressColor, backgroundColor = param.backgroundColor, _size = param.size, size = _size === void 0 ? 3 : _size, description = param.description, _descriptionPlacement = param.descriptionPlacement, descriptionPlacement = _descriptionPlacement === void 0 ? "center" : _descriptionPlacement;
    var ref = (0,react.useState)(0), offset = ref[0], setOffset = ref[1];
    size *= 16;
    strokeWidth *= 16;
    var center = size / 2;
    var radius = size / 2 - strokeWidth / 2;
    var circumference = 2 * Math.PI * radius;
    (0,react.useEffect)(function() {
        setOffset((100 - (percent > 100 ? 100 : percent < 0 ? 0 : percent)) / 100 * circumference);
    }, [
        setOffset,
        circumference,
        percent
    ]);
    var _variant, _color, ref1, _size1, _rotate;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (progressCircle_module_default()).wrapper,
        style: {
            height: size,
            width: size
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: size,
                height: size,
                fill: backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : (progressCircle_module_default()).steel,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                            id: "gradient",
                            x1: "0%",
                            x2: "0%",
                            y1: "0%",
                            y2: "100%",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                    offset: "0%",
                                    stopColor: (progressCircle_module_default()).tertiary
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                    offset: "50%",
                                    stopColor: (progressCircle_module_default()).primary
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                    offset: "100%",
                                    stopColor: (progressCircle_module_default()).secondary
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: center,
                        cy: center,
                        r: radius,
                        strokeWidth: strokeWidth,
                        stroke: (progressCircle_module_default()).mattBlack
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        cx: center,
                        cy: center,
                        r: radius,
                        strokeWidth: strokeWidth,
                        strokeDasharray: circumference,
                        stroke: progressColor !== null && progressColor !== void 0 ? progressColor : "url(#gradient)",
                        strokeDashoffset: offset,
                        transform: "rotate(-90 ".concat(size / 2, " ").concat(size / 2, ")"),
                        style: {
                            transition: "stroke-dashoffset 0.5s linear"
                        }
                    })
                ]
            }),
            icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_icon/* Icon */.J, {
                className: (progressCircle_module_default()).icon,
                variant: (_variant = icon.variant) !== null && _variant !== void 0 ? _variant : "people",
                color: (ref1 = (_color = icon.color) !== null && _color !== void 0 ? _color : progressColor) !== null && ref1 !== void 0 ? ref1 : "gradient",
                size: (_size1 = icon.size) !== null && _size1 !== void 0 ? _size1 : size / 32,
                style: {
                    transform: "translate(-50%, -50%) rotate(".concat((_rotate = icon.rotate) !== null && _rotate !== void 0 ? _rotate : 0, "deg)")
                }
            }),
            description ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: classnames_default()((progressCircle_module_default()).text, (progressCircle_module_default())[descriptionPlacement]),
                children: description
            }) : !icon && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: classnames_default()((progressCircle_module_default()).text, (progressCircle_module_default()).center),
                style: {
                    fontSize: size / 3 - 2
                },
                children: [
                    percent,
                    "%"
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/ui/progress/index.tsx




/***/ }),

/***/ 45326:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#acf7f0","primaryaccent":"#8ed2cc","primaryhover":"#7cfff3","primaryfocus":"#4eb7ad","primarydisabled":"#547a77","secondary":"#f0acf7","secondaryAccent":"#d08bd7","secondaryDark":"#983fa1","tertiary":"#f7f0ac","void":"#0f0f0f","charcoal":"#1c1c1c","plastic":"#232323","steel":"#303030","mattBlack":"#393939","ashBlack":"#484848","white":"#efefef","middleGrey":"#8f8f8f","darkGrey":"#6b6b6b","yellowRedGradient":"linear-gradient(90deg, #f7f0ac 0%, #f0acf7 100%)","logoGradient":"linear-gradient(95deg, #f7f0ac 5%, #acf7f0 50%, #f0acf7 95%)","gradient":"linear-gradient(70deg, #acf7f0 0%, #f0acf7 100%)","success":"#53e72e","successDisabled":"#39711a","error":"#f44040","divider":"#b4b4b4","inputFontColor":"#ababab","inputFontDisabled":"#3f3f3f","muiPrimary":"#00e0b5","muiOnPrimary":"#00382b","muiPrimaryContainer":"#005140","muiOnPrimaryContainer":"#0dffd2","muiSecondary":"#b2cdc2","muiOnSecondary":"#1d352e","muiSecondaryContainer":"#344c44","muiOnSecondaryContainer":"#cee9de","muiTertiary":"#a9cbe2","muiOnTertiary":"#0e3446","muiTertiaryContainer":"#294b5e","muiOnTertiaryContainer":"#c4e7ff","muiError":"#ffb4a9","muiErrorContainer":"#930006","muiOnError":"#680003","muiOnErrorContainer":"#ffdad4","muiBackground":"#161818","muiOnBackground":"#e0e3e0","muiSurface":"#191c1b","muiOnSurface":"#e0e3e0","muiSurfaceVariant":"#3f4945","muiOnSurfaceVariant":"#bfc9c4","muiSurface1":"#202222","muiSurface2":"#252727","muiSurface3":"#292b2b","muiSurface4":"#2e3030","muiSurface5":"#323434","muiOutline":"#89938e","muiInverseOnSurface":"#191c1b","muiInverseSurface":"#e0e3e0","muiInversePrimary":"#006b55","muiWhite":"#fff","muiBlack":"#000","muiNeutral30":"#444846","muiNeutral40":"#5c5f5d","muiBoxShadow1":"\"0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow2":"\"0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow3":"\"0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow4":"\"0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow5":"\"0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3)\"","idTarget":"progressBar_idTarget__f6Qwi","fabulousText":"progressBar_fabulousText__0jAyS","rainbow":"progressBar_rainbow__SOGm8","errorText":"progressBar_errorText__Gm_J3","barWrapper":"progressBar_barWrapper__fv6So","barBackground":"progressBar_barBackground____FRh","barFill":"progressBar_barFill__EpGBY","text":"progressBar_text__iTv1A"};

/***/ }),

/***/ 38659:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#acf7f0","primaryaccent":"#8ed2cc","primaryhover":"#7cfff3","primaryfocus":"#4eb7ad","primarydisabled":"#547a77","secondary":"#f0acf7","secondaryAccent":"#d08bd7","secondaryDark":"#983fa1","tertiary":"#f7f0ac","void":"#0f0f0f","charcoal":"#1c1c1c","plastic":"#232323","steel":"#303030","mattBlack":"#393939","ashBlack":"#484848","white":"#efefef","middleGrey":"#8f8f8f","darkGrey":"#6b6b6b","yellowRedGradient":"linear-gradient(90deg, #f7f0ac 0%, #f0acf7 100%)","logoGradient":"linear-gradient(95deg, #f7f0ac 5%, #acf7f0 50%, #f0acf7 95%)","gradient":"linear-gradient(70deg, #acf7f0 0%, #f0acf7 100%)","success":"#53e72e","successDisabled":"#39711a","error":"#f44040","divider":"#b4b4b4","inputFontColor":"#ababab","inputFontDisabled":"#3f3f3f","muiPrimary":"#00e0b5","muiOnPrimary":"#00382b","muiPrimaryContainer":"#005140","muiOnPrimaryContainer":"#0dffd2","muiSecondary":"#b2cdc2","muiOnSecondary":"#1d352e","muiSecondaryContainer":"#344c44","muiOnSecondaryContainer":"#cee9de","muiTertiary":"#a9cbe2","muiOnTertiary":"#0e3446","muiTertiaryContainer":"#294b5e","muiOnTertiaryContainer":"#c4e7ff","muiError":"#ffb4a9","muiErrorContainer":"#930006","muiOnError":"#680003","muiOnErrorContainer":"#ffdad4","muiBackground":"#161818","muiOnBackground":"#e0e3e0","muiSurface":"#191c1b","muiOnSurface":"#e0e3e0","muiSurfaceVariant":"#3f4945","muiOnSurfaceVariant":"#bfc9c4","muiSurface1":"#202222","muiSurface2":"#252727","muiSurface3":"#292b2b","muiSurface4":"#2e3030","muiSurface5":"#323434","muiOutline":"#89938e","muiInverseOnSurface":"#191c1b","muiInverseSurface":"#e0e3e0","muiInversePrimary":"#006b55","muiWhite":"#fff","muiBlack":"#000","muiNeutral30":"#444846","muiNeutral40":"#5c5f5d","muiBoxShadow1":"\"0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow2":"\"0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px rgba(0, 0, 0, 0.3)\"","muiBoxShadow3":"\"0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow4":"\"0px 6px 10px 4px rgba(0, 0, 0, 0.15), 0px 2px 3px rgba(0, 0, 0, 0.3)\"","muiBoxShadow5":"\"0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3)\"","idTarget":"progressCircle_idTarget__6SvVD","fabulousText":"progressCircle_fabulousText__cLIjJ","rainbow":"progressCircle_rainbow__rDQXd","errorText":"progressCircle_errorText__hS0Vr","wrapper":"progressCircle_wrapper__n1mw7","text":"progressCircle_text__iNJwc","center":"progressCircle_center__IHgFl","left":"progressCircle_left___3ah6","right":"progressCircle_right__IatmM","top":"progressCircle_top___AJLb","bottom":"progressCircle_bottom___qdtZ","icon":"progressCircle_icon__taAnr"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [621,534,213,774,888,179], function() { return __webpack_exec__(91516); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);